export default __webpack_public_path__ + "static/media/share_assessment.e28f325d.svg";